<div class="flex gap-3">
  <!-- Facebook -->
  <a href="https://www.facebook.com/skillz.vzw" target="_blank">
    <svg-icon
      class="fill-white hover:fill-secondary"
      src="/assets/icons/facebook.svg"
    />
    <span class="sr-only">Facebook</span>
  </a>

  <!-- Instagram -->
  <a href="https://www.instagram.com/skillz_vzw/" target="_blank">
    <svg-icon
      class="fill-white hover:fill-secondary"
      src="/assets/icons/instagram.svg"
    />
    <span class="sr-only">Instagram</span>
  </a>

  <!-- LinkedIn -->
  <a href="https://nl.linkedin.com/company/skillz.be" target="_blank">
    <svg-icon
      class="fill-white hover:fill-secondary"
      src="/assets/icons/linkedin.svg"
    />
    <span class="sr-only">LinkedIn</span>
  </a>

  <!-- YouTube -->
  <a
    href="https://www.youtube.com/channel/UCpK0wTYx0kinGYR62GhD2DA/videos"
    target="_blank"
  >
    <svg-icon
      class="fill-white hover:fill-secondary"
      src="/assets/icons/youtube.svg"
    />
    <span class="sr-only">YouTube</span>
  </a>

  <!-- TikTok -->
  <a href="https://www.tiktok.com/@skillz.vzw_" target="_blank">
    <svg-icon
      class="fill-white hover:fill-secondary"
      src="/assets/icons/tiktok.svg"
    />
    <span class="sr-only">TikTok</span>
  </a>
</div>
